var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":function($event){return _vm.printResponse(...arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }